import React, {
  FC,
  memo,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { Image } from 'components';

import { LanguageContext } from 'context/languageContext';
import { LanguageType, selectLanguage } from './menu';

import styles from './styles.module.scss';

interface ILangMenu {
  isLabel?: boolean;
  classNameBox?: string;
  classNameMenu?: string;
  classNameContainer?: string;
  langBanner?: string;
  onChangeLangBanner?: (v: string) => void;
  hidden?: boolean;
  isLandingPage?: boolean;
}

export const LangMenu: FC<ILangMenu> = memo(({
  isLabel,
  classNameBox,
  classNameMenu,
  classNameContainer,
  langBanner,
  onChangeLangBanner,
  hidden,
  isLandingPage = false,
}) => {
  const { i18n } = useTranslation();

  const languageAdditional = useMemo(() => selectLanguage, []);

  const currentLanguage = languageAdditional.find(({ value }) => value === i18n.language);
  const bannerLang = languageAdditional.find(({ value }) => value === langBanner);
  const [lang, setLang] = useState(bannerLang || currentLanguage || languageAdditional[0]);
  const [isOpenLang, setIsOpenLang] = useState(false);
  const { setLanguage } = useContext(LanguageContext);

  const changeLanguage = useCallback((language?: LanguageType) => {
    if (onChangeLangBanner && language?.value) {
      onChangeLangBanner(language.value);
      setLang(language);
    }
    if (!onChangeLangBanner && language?.value) {
      setLang(language);
      i18n.changeLanguage(language.value);
      localStorage.setItem('lng', language.value);
      setLanguage(language.value);
    }
    setIsOpenLang(!isOpenLang);
  }, [isOpenLang, i18n, onChangeLangBanner, setLanguage]);

  return (
    <div
      style={{ display: hidden ? 'none' : 'flex' }}
      className={cn(styles.lang_controls_lang, {
        [styles.lang_controls_lang_label]: isLabel,
      }, classNameContainer)}
    >
      <button
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        onClick={changeLanguage}
        className={cn(styles.lang_controls, {
          [styles.lang_controls_label]: isLabel,
        }, classNameBox)}
      >
        <Image
          url={lang.icon}
          className={styles.lang_controls_selected_language}
        />
        {isLabel && (
          <div className={styles.lang_label}>
            {lang.label}
          </div>
        )}
      </button>
      {isOpenLang && (
        <div
          className={cn(styles.lang_controls_menu, {
            [styles.lang_controls_menu_label]: isLabel,
            [styles.lang_controls_menu_top]: isLandingPage,
            [styles.lang_controls_menu_bottom]: !isLandingPage,
          }, classNameMenu)}
        >
          {languageAdditional.map((language) => (
            <button
              key={language.value}
              onClick={() => changeLanguage(language)}
              className={cn(styles.lang_controls, {
                [styles.lang_controls_label]: isLabel,
                [styles.lang_controls_active]: language.label === lang.label,
              }, classNameBox)}
            >
              <Image url={language.icon} />
              {isLabel && (
                <div className={styles.lang_label}>
                  {language.label}
                </div>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
});
